import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

export const ProtectedRoute = ({children}) => {
    const currentUser = useSelector((state) => state.auth.user);
    const location = useLocation();
    if(!currentUser) {
        return <Navigate to="/login" state={{from: location}} />;
    }

    return children;
}
